import type { OperatorRigState } from "@common/utils/operatorRig";

/** Pixi source.update uploads immediately once bound. Batch shared atlas pages. */
export class OperatorUploadQueue {
    private readonly pending = new Set<{ update(): void }>();
    mark(source: { update(): void }): void { this.pending.add(source); }
    flush(): void {
        for (const source of this.pending) {
            source.update();
            this.pending.delete(source);
        }
    }
}

/** Exact comparison: never round yaw, phase, grips or gesture progress. */
export function sameOperatorPose(a: OperatorRigState | undefined, b: OperatorRigState): boolean {
    return !!a && a.rotation === b.rotation && a.phase === b.phase && a.moving === b.moving
        && a.moveAngle === b.moveAngle && a.gesture === b.gesture && a.gesturePhase === b.gesturePhase
        && a.skinId === b.skinId && a.helmet === b.helmet && a.vest === b.vest && a.backpack === b.backpack
        && a.carry === b.carry && a.armMotion === b.armMotion
        && a.runStride === b.runStride && a.weaponLift === b.weaponLift && a.weaponSway === b.weaponSway
        && a.compactArms === b.compactArms
        && a.leftHand.x === b.leftHand.x && a.leftHand.y === b.leftHand.y
        && a.rightHand.x === b.rightHand.x && a.rightHand.y === b.rightHand.y;
}

/** Conservative camera rectangle only. It deliberately knows nothing about roof,
 * canopy, floor or bush concealment; those remain owned by the existing game. */
export function operatorInsideRenderBounds(dx: number, dy: number, width: number, height: number, zoom: number, radius: number): boolean {
    if (zoom <= 0 || width <= 1 || height <= 1) return true;
    return Math.abs(dx) <= width / (2 * zoom) + radius && Math.abs(dy) <= height / (2 * zoom) + radius;
}
